import { useRegisterSupportOrganizationCount } from "@/api/services/admin/rso";
import { TGetRegisterSupportOrganizationCountDto } from "@/api/services/admin/rso/dtos/get-rso-count.dto";

export const useGetRsoTotalCount = (keyword?: string): TGetRegisterSupportOrganizationCountDto => {
  const { data: rsoCount } = useRegisterSupportOrganizationCount({ keyword: keyword || undefined });

  return {
    duringContractCount: rsoCount?.data?.duringContractCount ?? 0,
    canceledContractCount: rsoCount?.data?.canceledContractCount ?? 0,
    trialCount: rsoCount?.data?.trialCount ?? 0,
    trialCancelledCount: rsoCount?.data?.trialCancelledCount ?? 0,
  };
};
